import { useState } from 'react';

export function SectionHeader({ eyebrow, title, description, children, centered = true }) {
  return (
    <div className={'in-section__header' + (centered ? '' : '')} data-aos="fade-up">
      {eyebrow && <span className="in-section__eyebrow">{eyebrow}</span>}
      {title && <h2 className="in-section__title">{title}</h2>}
      {description && <p className="in-section__desc">{description}</p>}
      {children}
    </div>
  );
}

export function ServiceCard({ icon, iconLogo, title, description, links, delay = 0 }) {
  return (
    <article className="in-card" data-aos="fade-up" data-aos-delay={delay}>
      <div className={'in-card__icon' + (iconLogo ? ' in-card__icon--logo' : '')}>
        {iconLogo ? <img src={iconLogo} alt="" /> : <i className={icon} />}
      </div>
      <h3 className="in-card__title">{title}</h3>
      <p className="in-card__text">{description}</p>
      <div className="in-card__links">
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target={link.external ? '_blank' : undefined}
            rel={link.external ? 'noopener noreferrer' : undefined}
          >
            {link.label}
          </a>
        ))}
      </div>
    </article>
  );
}

export function ContactCta({ title, citySuffix = '', suffix = '?', description, subtitle }) {
  return (
    <section className="in-cta">
      <div className="in-container">
        <div className="in-cta__inner" data-aos="fade-up">
          <h2>
            {title}
            {citySuffix && <span>{citySuffix}</span>}
            {suffix}
          </h2>
          <p>
            {description ||
              'Entre em contato com nossa equipe e teremos o prazer em atender o seu pedido.'}
          </p>
          {subtitle && (
            <p className="in-cta__subtitle">
              <strong>{subtitle}</strong>
            </p>
          )}
          <a
            href="https://wa.me/5544991775641"
            className="in-btn in-btn--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Solicite um orçamento
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}

export function FaqAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="in-faq">
      {items.map((item, index) => (
        <div
          key={item.question}
          className={'in-faq__item' + (openIndex === index ? ' in-faq__item--open' : '')}
        >
          <button
            type="button"
            className="in-faq__q"
            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            aria-expanded={openIndex === index}
          >
            {item.question}
            <i className="ri-add-line" />
          </button>
          <div className="in-faq__a">
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
